<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex  xs12 sm10 md8>
          <v-img
              alt="Flexline logo"
              flex
              src="../assets/Flexline Toolbar Logo(400 x 100 px).png"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  }
}
</script>
